/*
   takes in ID of the Job Template
   and display the full template based on that.

   does a fetch request whenever it feels like
   user is attempting to load new template.
*/

import React, { useEffect, useState } from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import { Label } from "reactstrap";

import { UpwardAdvancedLoader } from 'ui/index';
import { getTemplateDescription } from "../../../../services/suggestions/job";
import { BehaviorSubject } from "rxjs";
import { switchMap, tap, map, filter, distinctUntilChanged } from "rxjs/operators";

const templateIdSubject$ = new BehaviorSubject(null);

const JobTemplateDisplay = (props) => {

   const [isLoading, setIsLoading] = useState(false);
   const [template, setTemplate] = useState(null);
   const [templateId, setTemplateId] = useState(props.templateId ? +props.templateId : null);

   useEffect(() => {
      setTemplateId(+props.templateId);
      templateIdSubject$.next(+props.templateId);
   }, [props.templateId]);


   useEffect(() => {
      if (props.onTemplateLoad) {
         props.onTemplateLoad(template);
      }
   }, [template]);

   useEffect(() => {
      const subscription = templateIdSubject$.pipe(
         filter((value) => !!value),
         distinctUntilChanged(),
         tap(() => { setIsLoading(true); }),
         switchMap((id) => {
            return getTemplateDescription(id).pipe(
               map((data) => data)
            )
         })
      ).subscribe(
         (data) => {
            if (data && data.template) {
               setTemplate({ ...data.template });
               setIsLoading(false);
            }
         }
      );
      return () => {
         if (subscription) {
            subscription.unsubscribe();
         }
      }
   }, []);

   return (
      <div>
         <Label>Job template Preview</Label>
         <div className="border rounded" style={{ "height": "65vh" }}>
            <PerfectScrollbar>
               <div>
                  { isLoading && <UpwardAdvancedLoader size="120" /> }

                  { !isLoading && template && template.id &&
                     <div>
                        <div className="p-3 border-bottom">
                           { template.title }&nbsp;
                        </div>
                        <div
                           className="p-3"
                           dangerouslySetInnerHTML={{ __html: template.description }}
                        />
                     </div>
                  }
               </div>
            </PerfectScrollbar>
         </div>
      </div>
   )
}

export default JobTemplateDisplay;
